import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

const EntranceExamination = () => {
  useEffect(() => {
    document.title =
      "XI Class Entrance Test Result - St Peters Convent School Faridabad Haryana";
  }, []);

  // Data for rendering cards
  const classes = [
    { name: "8.11.2025( 1st Allotment List )", pdf: "first-1.pdf" },
    {
      name: "Date-  8.11.2025( 2nd Allotment List )",
      pdf: "second-2.pdf",
    },
    {
      name: "Date-  22.11.2025( 1st Allotment List )",
      pdf: "third-3.pdf",
    },
    {
      name: "Date-  22.11.2025( 2nd Allotment List )",
      pdf: "fourth-4.pdf",
    },
    {
      name: "Date-  27.12.2025( 1st Allotment List )",
      pdf: "fifth-5.pdf",
    },
    {
      name: "Date-  27.12.2025( 2nd Allotment List )",
      pdf: "sixth-6.pdf",
    },
  ];

  const images = ['pcm.png', 'pcb.png', 'commerceW_Maths.png','commercew_o_Maths.png', 'arts.png'];

  return (
    <>
      <Header />

      {/* Breadcrumb */}
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Admission</li>
          <li>Interaction and Entrance Examination Result</li>
        </ul>
      </div>

      {/* Main Section */}
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>XI Class Entrance Test Result</h1>
            </div>
          </div>

          {/* Images Gallery with Magnify */}
          <div className="row mt-4">
            {images.map((img, index) => (
              <div key={index} className="col-lg-6 col-md-12 col-sm-12 col-12 mb-4">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/${img}`}
                >
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/${img}`}
                    alt={img}
                    className="img-fluid"
                    style={{ cursor: 'zoom-in' }}
                  />
                </a>
              </div>
            ))}
          </div>

          {/* Cards Row */}
          {/* <div className="row">
            {classes.map((cls, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">{cls.name}</h6>
                    <a
                      href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/${cls.pdf}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="click-text"
                    >
                      Click Here →
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default EntranceExamination;
